module.exports = __webpack_public_path__ + "static/media/sic_deuda.64d87870.svg";